module.exports = __webpack_public_path__ + "img/c_3.316e3720.jpg";